// extracted by mini-css-extract-plugin
export var bodySections = "_bb-8";
export var gray = "_bb-7";
export var green = "_bb-4";
export var iconContainer = "_bb-9";
export var iconWidgetContainer = "_bb-1";
export var phoneIcon = "_bb-2";
export var red = "_bb-5";
export var statusDot = "_bb-3";
export var widgetContainer = "_bb-0";
export var yellow = "_bb-6";